import styles from './VnewsModal.module.css'

import { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';

// Modal
import { useModalWindow } from "react-modal-global";
import useScrollBlock from '../../../../customHooks/useScrollBlock';
import PopupAppearLayout from '../../common/Modals/Layouts/PopupAppearLayout';
// Icons
import icon_close from "../../assets/img/icons/close.svg";

const VNewsModal = ({data}) => {
    const [content, setContent] = useState('');
    useEffect( ()=>{
        setContent(DOMPurify.sanitize(data.content)); // Sanitize content
    }, [])

    const modal = useModalWindow();
    const [blockScroll, allowScroll] = useScrollBlock();

    const closeModal = () => {
      // setTimeout(function(){allowScroll()}, 150);
      allowScroll()
      modal.close()
    }   
    
                 
    return (
        <PopupAppearLayout classNameLayout={styles.popup__layout}>
            {/* Плавающая кнопка закрытия */}
            <button
                className={styles.floatingCloseBtn}
                type="button"
                onClick={closeModal}
            >
                <img src={icon_close} alt='close' />
            </button>

            <div className={styles.scrollContainer}>
                <div className={styles.header_container}>
                    <p className={styles.header_date}>{data.date}</p>
                    <h3 className={styles.header_title}>{data.title}</h3>
                </div>

                <div className={styles.login__container}>
                    <div className={styles.image_container}>
                        <img className={styles.img} src={'assets/img/by_page/news/' + data.img_url_main} alt='news' />
                    </div>
                    <p className={styles.content} dangerouslySetInnerHTML={{ __html: content }} />
                    <div className={styles.btn_container}>
                        <button
                            className={styles.btn_close}
                            type="button"
                            onClick={closeModal}
                        >
                            Закрыть
                        </button>
                    </div>
                </div>
            </div>
        </PopupAppearLayout>
    );         
}

export default VNewsModal;
